import type { PortalClientDto } from '@supply-mover-2-0/shared';

/**
 * Customer-facing client id: the external id (what the customer knows
 * themselves as with this vendor), falling back to the internal id —
 * same convention as the CRM's identity displays.
 */
export function clientDisplayId(
	client: Pick<PortalClientDto, 'id' | 'externalId'>,
): string {
	return client.externalId != null && client.externalId !== ''
		? client.externalId
		: String(client.id);
}
